import { render, staticRenderFns } from "./ProductImageUpdate.vue?vue&type=template&id=a40a6138&"
import script from "./ProductImageUpdate.vue?vue&type=script&lang=ts&"
export * from "./ProductImageUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports